// import { useQuery } from "@tanstack/react-query";
import api from "../../axios";

export const addFeedBack = async (data) => {
    const response = await api.post("/feedback", data);
    return response;
  };